import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Label from "../../../components/Label/Label";
import { useLocation, useNavigate } from "react-router-dom";
import { plotTypeOptions } from "../visualization/constants";
import { useSelector } from "react-redux";

const tabOptions = [
  { label: "Visualization", value: "visualization" },
  { label: "Process", value: "process" },
  { label: "Limits", value: "limits" },
  { label: "Batches", value: "batches" },
  { label: "Reports", value: "reports" },
  // { label: "Audit Trail", value: "audit-trail" },
  // { label: "Genealogy", value: "genealogy" },
  { label: "Dashboard", value: "dashboard" },
];

export default function TabsBar() {
  // {
  // isButtonVisible,
  // handleExportPDF,
  // handleExportXLS,
  // handleImportXLS,
  // }
  const navigate = useNavigate();
  const location = useLocation();

  const { product, site, unitOfOperation } = useSelector(
    (state) => state.shared.productSitesUopValues || {},
  );

  // const [selectedTab, setSelectedTab] = useState("");

  // const [anchorMenu, setAnchorMenu] = useState(null);

  const handleNavigate = (tab) => {
    // setSelectedTab(tab);
    navigate(`/analytics/${tab}`);
  };

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const mainTab = pathSegments[1]; // "visualization"

  const selectedTab =
    tabOptions.find((tab) => tab.value === mainTab)?.value || null;

  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      sx={{ px: 2, paddingBottom: 1, paddingRight: "0px" }}
    >
      <Grid item sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
        {tabOptions.map((tab) => {
          const isSelected = selectedTab === tab.value;
          const isDisabled =
            selectedTab === "reports" || selectedTab === "process"
              ? false
              : !unitOfOperation?.id;
          return (
            <Button
              key={tab.value}
              // disabled={isDisabled}
              variant="text"
              onClick={() => handleNavigate(tab.value)}
              size="small"
              sx={{
                textTransform: "none",
                minWidth: `${Math.max(tab.label.length * 7 + 16, 60)}px`,
                padding: "4px 8px",
                backgroundColor: isSelected ? "#154D8F" : "transparent",
                color: isSelected ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor: isSelected ? "#154D8F" : "transparent",
                },
                "&.Mui-disabled": { color: "#a0a0a0", pointerEvents: "auto" },
              }}
            >
              <Label text={tab.label} color={isSelected ? "#fff" : "#000"} />
            </Button>
          );
        })}
      </Grid>
      {/* <Grid item sx={{ marginLeft: "auto" }}>
        {isButtonVisible && (
          <>
            <IconButton onClick={(e) => setAnchorMenu(e.currentTarget)}>
              <MoreVert />
            </IconButton>
            <Menu
              anchorEl={anchorMenu}
              open={openOptionsMenu}
              onClose={() => setAnchorMenu(null)}
            >
              <MenuItem onClick={handleExportPDF}>
                <ListItemText>Export PDF</ListItemText>
              </MenuItem>
              <MenuItem onClick={handleExportXLS}>
                <ListItemText>Export XLS</ListItemText>
              </MenuItem>
              <MenuItem onClick={handleImportXLS}>
                <ListItemText>Import XLS</ListItemText>
              </MenuItem>
            </Menu>
          </>
        )}
      </Grid> */}
    </Grid>
  );
}
